import { uf } from "../models";

export default {
  actions: {
    // функиция помечает счет как проведенный
    accountTie({ dispatch, getters }, { id, date, valueBills }) {
      let addName; // имя проведенного счета в операции
      let href; // ссылка на  проведенный счет в операцию
      // получаем поля счета
      let fields;

      dispatch("getInvoice", { id, date }).then((invoice) => {
        if (invoice) {
          fields = invoice;
          addName = fields.ORDER_TOPIC;
          href =
            "https://" + obj.domain + "/crm/invoice/show/" + fields["ID"] + "/";
          fields["STATUS_ID"] = "P";
          fields["PAY_VOUCHER_DATE"] = date;
        } else {
          let msg = "Ошибка запроса счёта Б24";
          dispatch("alertInfo", msg, { root: true });
        }

        // TODO Сделать рефакторинг - вынесьти все данные в actions
        // изменяем статус счета на Оплаченный
        BX24.callMethod(
          "crm.invoice.update",
          {
            id: id,
            fields: fields,
          },
          function (result2) {
            if (result2.error()) {
              let alert = "Счет не провелся";
              dispatch("alertInfo", alert, { root: true });
              console.error(result2.error());
            } else {
              bitrixEntityGet();
            }
          }
        );

        // получаем из хранилища б24 все операции из раздела (счета) за указанный период
        function bitrixEntityGet() {
          BX24.callMethod(
            "entity.item.get",
            {
              ENTITY: "store",
              filter: {
                NAME: valueBills.TransactionUID,
              },
            },
            function (result) {
              if (result.error()) {
                let alert = "Ошибка запроса сета Б24";
                dispatch("alertInfo", alert, { root: true });
                console.error(result.error());
              } else {
                let item = result.data();
                accountChange(item[0].ID, item[0].DETAIL_TEXT);
              }
            }
          );
        }

        // добавляет данные о счете в операции
        function accountChange(id, text) {
          let newText = JSON.parse(text);
          newText["nameBill"] = addName;
          newText["hrefBill"] = href;

          BX24.callMethod(
            "entity.item.update",
            {
              ENTITY: "store",
              id: id,
              DETAIL_TEXT: JSON.stringify(newText),
            },
            function (result) {
              if (result.error()) {
                let alert = "Ошибка обновления операции";
                dispatch("alertInfo", alert, { root: true });
                console.error(result.error());
              } else {
                dispatch("bitrixTrans", { load: "load" }, { root: true });
              }
            }
          );
        }
      });
    },

    handlerHours({ dispatch }, payloads) {
      let purchasedHours = 0;
      const products = invoice.PRODUCT_ROWS;
      if (products && products.length) {
        // Перебираем все товары и смотрим их секцию. Интересует 1833
        products.forEach((product) => {
          if (
            getters.getProductSection(product.PRODUCT_ID).SECTION_ID == 1833
          ) {
            if (product.QUANTITY) purchasedHours += +product.QUANTITY;
          }
        });
        console.log("добавляем часы в Сделку: " + purchasedHours);
      }
      // Если сумма часов больше нуля (были товары с валидным количеством) и есть Сделка, то делаем запрос Сделки, чтобы получить часы купленные
      if (purchasedHours && invoice.UF_DEAL_ID)
        dispatch("getDeal", invoice.UF_DEAL_ID).then((deal) => {
          console.log(deal);

          // Проверям есть ли поле в Сделке (если на портале нет, то ничего не делаем)
          console.log(deal[uf.deal.estimatedBuy]);
          if (deal.hasOwnProperty(uf.deal.estimatedBuy)) {
            // Скалыдваем часы которые были в сделке и вновь купленные
            purchasedHours += +deal[uf.deal.estimatedBuy];
            // TODO Сделать запрос пользователю с инфомрацией для подтверждения данных
            alert;
            // Делаем запрос на обновление Сделки
          }
        });
    },
  },
};
